
/**
 * @nullable
 */
export type SendNotificationRequestSender = { [key: string]: unknown } | null;
